export const DEV_API_URL = 'https://dev.api.endress.com:443/';
export const DEV_API_KEY = 'zG3W0B7kNlMC6YoADYTWEGmhJIPZj8PZ';
export const QAS_API_URL = 'https://qas.api.endress.com:443/';
export const QAS_API_KEY = '9Gx74BahDV5LzYqA1VLuEvQllJBVjFHk';
export const PROD_API_URL = 'https://api.endress.com:443/';
export const PROD_API_KEY = 'W44EgF5BtuDYbFYCo9x58wgUGxNZDmLz';
